import DrmType from '../Constants/DrmType';

/**
 * A simple solution for inferring DRM type based on the provided manifest or
 * source.
 *
 * TODO: Will need to include additional browser detection logic when we
 * bring PlayReady to DASH, and the presense of a DASH manifest is no longer
 * exclusive to widevine.
 */

const inferDrmTypeFromSrc = (src: string): DrmType => {
    if (src.match(/\.mpd/)) {
        return DrmType.WIDEVINE;
    } else if (src.match(/\.m3u/)) {
        return DrmType.FAIRPLAY;
    } else if (src.match(/\.ism/)) {
        return DrmType.PLAYREADY;
    }

    return DrmType.NONE;
};

export default inferDrmTypeFromSrc;